// extracted by mini-css-extract-plugin
module.exports = {"header":"Accordion_header__8FFPa","container":"Accordion_container__3FHB8","content":"Accordion_content__mJ_UZ","text":"Accordion_text__hygl_"};